import React, { ReactNode } from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}
export function PageHeader({
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between" data-id="element-215" data-mp="15y5aupywgphb">
      <div data-id="element-216" data-mp="19yfq6t8l0s8u">
        <h1 className="text-2xl font-semibold tracking-tight text-navy sm:text-[28px]" data-id="element-217" data-mp="19y7bqwwt9evj">
          {title}
        </h1>
        {description && <p className="mt-1.5 text-sm text-muted-foreground" data-id="element-218" data-mp="w69d5g0q71dm">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2" data-id="element-219" data-mp="10zloioge9bof">{actions}</div>}
    </div>;
}